import { createFileRoute } from '@tanstack/react-router';

import { ClientLibraryDetailScreen } from '@/features/engagement/components/ClientLibraryDetailScreen';

export const Route = createFileRoute('/client/library/$resourceId')({
  component: ClientLibraryDetailRoute,
});

function ClientLibraryDetailRoute() {
  const { resourceId } = Route.useParams();
  return <ClientLibraryDetailScreen resourceId={resourceId} />;
}
